import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import styled from '@emotion/styled';
import moment from 'moment';

import FiltersRow from './FiltersRow';

import SpinnerBlock from '../../common/SpinnerBlock';
import Pagination from '../../common/Pagination';

import {
  badgesStyle,
  ORDERS_PAGE_TABS,
  TAG_COLORS,
  INFO_STATUS_BAR_TRANSLATE,
} from '../../../config';

import Background from '../../../assets/images/base_registration_background.png';
import OrdersSkeleton from './OrdersSkeleton';
import { useSelector } from 'react-redux';

const OrdersTabsWrapper = styled('div')`
  position: relative;
  width: calc(100% + 10px);
  display: flex;

  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    top: 0;
    bottom: 2px;
    width: 100px;
  }

  &.leftShadowed::before {
    background: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    left: 0;
    opacity: 1;
  }

  &.rightShadowed::after {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    opacity: 1;
    right: 0;
  }

  .nav-tabs-container {
    display: flex;
    padding: 0 5px;
    overflow-x: auto;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #93959d;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .nav-tabs-wrapper {
    display: inline-block;
  }

  .nav-tabs-orders {
    display: flex;
    flex-wrap: nowrap;
  }

  .tab-title {
    white-space: nowrap;
  }

  .nav-link {
    padding: 5px 15px 7px;
    position: relative;

    &.active {
      color: #7e57c2;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 10px;
        width: calc(100% - 20px);
        height: 2px;
        background: #7e57c2;
      }
    }
  }

  .badge-pill {
    background: #f2f5f7;
    border-radius: 5px;
    margin-left: 5px;
    color: inherit;
    padding: 0 7px;
    line-height: 15px;
  }
`;

const OrdersCardWrapper = styled('div')`
  margin: 0 -7px;

  .form-inline {
    margin-top: 15px;
    display: block;
    position: relative;

    button {
      position: absolute;
      right: 5px;
      top: 5px;
      border-radius: 3px;
    }

    .form-group {
      margin-bottom: 15px !important;
    }
  }

  .filters-row {
    .extra-content {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 15px;
    }

    .select {
      width: 100%;
      padding: 0 !important;
    }

    a.btn i {
      display: none;
    }
  }

  .select {
    width: 50%;
    padding-left: 7.5px !important;

    > div {
      flex-grow: 1;
      min-width: 50% !important;
      max-height: 36px;

      .react-select-container {
        height: 100%;

        .react-select__control {
          height: 100%;
          box-sizing: border-box;
          min-height: 0;
        }
      }
    }
  }

  .packing-button-wrapper {
    display: none !important;
    padding-left: 7.5px !important;
    flex: 0 1 50% !important;
    max-width: 50%;

    button {
      white-space: nowrap;
      padding: 0;

      .badge {
        display: none;
      }
    }
  }

  .form-control {
    border-radius: 5px;
  }

  .new-order {
    position: fixed;
    right: 6%;
    bottom: 4%;
    z-index: 1;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    font-size: 24px;

    span {
      display: none;
    }
  }

  .order-card {
    background: white;
    border: 1px solid #e3e5e7;
    border-radius: 5px;
    margin-top: 15px;
    padding: 10px 15px;
    position: relative;
    display: block;
    color: #98a6ad;
    font-size: 11px;
    display: grid;
    grid-gap: 5px 0;
    align-items: center;
    grid-template-columns: 1fr 60px 50px;
    grid-template-areas: 't i p' 'r r r' 's s s';

    &.canceled {
      filter: opacity(65%) grayscale(100%);
    }

    .mark-wrapper {
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      width: 4px;
      border-radius: 0 2px 2px 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .mark {
        flex: 1 1 auto;
        background: transparent;
        margin-bottom: 1px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .order-date-id {
      grid-area: t;
      display: flex;
      align-items: center;

      .order-id {
        font-size: 13px;
        font-weight: bold;
        color: #72747b;
        margin-right: 5px;
        line-height: 22px;
      }

      .order-date {
        font-size: 12px;
        line-height: 22px;
      }
    }

    .delivery-logo {
      grid-area: i;
      width: 100%;
      height: 22px;
      object-fit: contain;

      &:not([src]) {
        visibility: hidden;
      }
    }

    .order-price {
      grid-area: p;
      text-align: right;
      font-weight: 500;
      color: #72747b;
      font-size: 13px;
      line-height: 22px;
    }

    .name {
      grid-area: r;
    }

    .order-states {
      grid-area: s;
      display: flex;
      margin: 5px 0;

      .badge,
      .order-delivery-state {
        font-size: 8px;
        padding: 0 12px;
        line-height: 15px;
        border-radius: 3px;
        font-weight: 500;
      }
    }
  }

  .col-lg-1 {
    flex-basis: 50%;
    display: flex;
    height: 36px;
    padding-right: 7.5px;
  }

  .btn-light {
    color: #323a46;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    flex-grow: 1;
    margin: 0 !important;
    background: white;
  }

  .col-lg-8 {
    flex-basis: 50%;
    display: flex;
    height: 36px;
    padding-left: 7.5px;

    div {
      display: flex;
      width: 100%;
    }
  }

  .tags-button {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .tag-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: 3px;
  }

  .pagination-wrapper {
    .col-12 {
      padding: 0 0 150px;
      margin: 15px -3px 0;
      background: url(${Background});
      background-size: cover;

      .float-right {
        float: none !important;
        display: flex;
        justify-content: center;
        background: white;
        border-top: 1px solid #e3e5e7;
        border-bottom: 1px solid #e3e5e7;
        width: calc(100% + 6px);
        max-width: none;
      }
    }
  }
  .reserve-icon {
    display: inline-block;
    background: #88c7eb;
    border-radius: 4px;
    padding: 0px 4px;
    margin-left: 5px;
    i {
      color: white;
      font-weight: lighter;
      font-size: 12px;
    }
    &.unactive {
      background: #d6dbde;
    }
  }

  .reserve-tip {
    padding: 2px 4px;
    position: absolute;
    border: 1px solid #dee2e6;
    background: white;
    width: max-content;
    color: #7f828b;
    font-weight: normal;
    z-index: 2;
    left: -20px;
    top: 26px;
  }
`;

const MobileCustomMenu = (props) => {
  const { handleOpenTab, statusesLoading, getTabOrdersLength, activeTab, statusesLength } = props;

  const handleScroll = (evt) => {
    const tabsWrapper = evt.target;
    if (tabsWrapper.scrollLeft) tabsWrapper.parentElement.classList.add(`leftShadowed`);
    else tabsWrapper.parentElement.classList.remove(`leftShadowed`);

    if (evt.target.scrollLeft - tabsWrapper.scrollWidth + tabsWrapper.offsetWidth)
      tabsWrapper.parentElement.classList.add(`rightShadowed`);
    else tabsWrapper.parentElement.classList.remove(`rightShadowed`);
  };

  return (
    <OrdersTabsWrapper onScroll={handleScroll} className="rightShadowed">
      <div className="nav-tabs-container">
        <div className="nav-tabs-wrapper">
          <ul className="nav nav-tabs-orders">
            {ORDERS_PAGE_TABS.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <div
                  data-toggle="tab"
                  aria-expanded="true"
                  className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleOpenTab(tab)}
                >
                  <div className="d-flex flex-row">
                    <div className="tab-title">{tab.title}</div>
                    {tab.states ? (
                      <div>
                        {!statusesLoading ? (
                          <span className="badge badge-pill">
                            {!tab.problems
                              ? getTabOrdersLength(tab, statusesLength)
                              : statusesLength['PROBLEM_ORDERS']}
                          </span>
                        ) : (
                          <span
                            className="spinner-border spinner-border-sm mr-1"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className={`nav-link-after ${activeTab === tab.id ? `active` : ``}`} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </OrdersTabsWrapper>
  );
};

const DeliveryInfoBlock = (props) => {
  const { status } = props;
  return (
    <div
      className="order-delivery-state"
      style={{
        ...badgesStyle[status],
        marginRight: 15,
      }}
    >
      {INFO_STATUS_BAR_TRANSLATE[status] ? INFO_STATUS_BAR_TRANSLATE[status] : `Unknown status`}
    </div>
  );
};

const MobileLayout = (props) => {
  const {
    selectedLength,
    activeTab,
    handleOpenTab,
    statusesLoading,
    getTabOrdersLength,
    statusesLength,
    orders,
    search,
    selected,
    showFilter,
    unpackingOrders,
    unpackingFilter,
    packingControlOrders,
    packingControlFilter,
    loadingReport,
    warehouses,
    activeWarehouse,
    setActiveWarehouse,
    handleSearch,
    setShowFilter,
    handleCloseFilter,
    handleSetFilters,
    handleSetUnpackingFilter,
    handleSetControlPacking,
    handleShippingOrders,
    handleNewOrder,
    updateOrders,
    updateStatuses,
    history,
    filterFormInitial,
    setFilterFormInitial,
    loading,
    filters,
    filteredOrders,
    urlSearchStr,
    scrollPosition,
    ReceiverBlock,
    PaymentInfoBlock,
    currencySymbol,
    totalItems,
    page,
    handlePageSelect,
    setMobileCustomMenu,
    isWrong,
    defaultReserveOrders,
    getCurrencySymbol,
  } = props;

  const [reserveTip, setReserveTip] = useState([]);

  useEffect(() => {
    setMobileCustomMenu(
      <MobileCustomMenu
        handleOpenTab={handleOpenTab}
        statusesLoading={statusesLoading}
        getTabOrdersLength={getTabOrdersLength}
        activeTab={activeTab}
        statusesLength={statusesLength}
      />,
    );
  }, [statusesLoading, activeTab, statusesLength, activeTab]);

  const isFetching = useSelector((state) => state?.orders?.getOrders?.isFetching);

  return (
    <>
      <div className="row" style={{ paddingTop: 30 }}>
        <div className="col-12">
          <OrdersCardWrapper>
            <FiltersRow
              orders={orders}
              search={search}
              statusesLength={statusesLength}
              selected={selected}
              selectedLength={selectedLength}
              showFilter={showFilter}
              activeTab={activeTab}
              unpackingOrders={unpackingOrders}
              unpackingFilter={unpackingFilter}
              packingControlOrders={packingControlOrders}
              packingControlFilter={packingControlFilter}
              loadingReport={loadingReport}
              warehouses={warehouses}
              activeWarehouse={activeWarehouse}
              setActiveWarehouse={setActiveWarehouse}
              handleSearch={handleSearch}
              setShowFilter={setShowFilter}
              handleCloseFilter={handleCloseFilter}
              handleSetFilters={handleSetFilters}
              handleSetUnpackingFilter={handleSetUnpackingFilter}
              handleSetControlPacking={handleSetControlPacking}
              handleShippingOrders={handleShippingOrders}
              handleNewOrder={handleNewOrder}
              updateOrders={updateOrders}
              updateStatuses={updateStatuses}
              history={history}
              filterFormInitial={filterFormInitial}
              setFilterFormInitial={setFilterFormInitial}
              loading={loading}
              filters={filters}
            />
            {filteredOrders.length > 0 && !isFetching && filteredOrders[0] !== 'NOT_FOUND' ? (
              filteredOrders.map((order) => (
                <Link
                  key={order.id}
                  className={`order-card ${
                    order.status === `ORDER_INFO_CANCELED` ? `canceled` : ``
                  }`}
                  style={isWrong(order) ? { color: `#f1556c` } : undefined}
                  to={{
                    pathname: `/orders/${order.id}`,
                    state: {
                      customBackLink: urlSearchStr
                        ? '/orders' + urlSearchStr + '&scroll=' + scrollPosition
                        : null,
                    },
                  }}
                >
                  <div className="mark-wrapper">
                    {order.tags && order.tags.length
                      ? order.tags
                          .map((item, index) => (
                            <span
                              key={index.toString()}
                              className="mark"
                              style={{
                                background: TAG_COLORS.find((color) => color.id === item.color)
                                  .code,
                              }}
                            />
                          ))
                          .slice(0, 4)
                      : null}
                  </div>
                  <div className="order-date-id">
                    <div className="order-id">{order.id}</div>
                    <div className="order-date">{moment(order.date).format(`DD MMM`)}</div>
                    {!defaultReserveOrders && !order.needReserve ? (
                      <div
                        className="reserve-icon unactive"
                        onMouseOver={() => setReserveTip([...reserveTip, order.id])}
                        onMouseOut={() => setReserveTip(reserveTip.filter((id) => id !== order.id))}
                      >
                        <i className="fe-shopping-bag" />
                        {reserveTip.includes(order.id) ? (
                          <div className="reserve-tip">Резерв не требуется</div>
                        ) : (
                          false
                        )}
                      </div>
                    ) : null}
                  </div>
                  <img className="delivery-logo" src={order.delivery.logoUrl} alt="" />
                  <div className="order-price">
                    {`${numeral(order.totalOrderSum).format('0,0')} ${
                      order.currency ? getCurrencySymbol(order.currency) : currencySymbol
                    }`}
                  </div>
                  <ReceiverBlock row={order} />
                  <div className="order-states">
                    <DeliveryInfoBlock status={order.status} />
                    <PaymentInfoBlock row={order} mobile />
                  </div>
                </Link>
              ))
            ) : isFetching || (!isFetching && !filteredOrders.length) ? (
              <>
                <OrdersSkeleton />
                <OrdersSkeleton />
                <OrdersSkeleton />
                <OrdersSkeleton />
                <OrdersSkeleton />
                <OrdersSkeleton />
                <OrdersSkeleton />
              </>
            ) : filteredOrders?.[0] === 'NOT_FOUND' ? (
              <tr>
                <td className="mt-2 fs-4" colspan="3">
                  Заказы не найдены
                </td>
              </tr>
            ) : null}
            <div className="pagination-wrapper">
              <Pagination
                total={totalItems}
                currentPage={Number(page)}
                onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
                itemsNaming="заказов"
              />
            </div>
          </OrdersCardWrapper>
        </div>
      </div>
    </>
  );
};

export default MobileLayout;
